import { render } from "./FooterMap.vue?vue&type=template&id=5f8bc2fb&scoped=true"
import script from "./FooterMap.vue?vue&type=script&lang=js"
export * from "./FooterMap.vue?vue&type=script&lang=js"

import "./FooterMap.vue?vue&type=style&index=0&id=5f8bc2fb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f8bc2fb"

export default script